import volumeSeller from '../../assets/external/volume-seller.svg';
import tradeRevDirectSeller from '../../assets/external/trd-shipping.svg';

// Add future icons to this map
const iconMap = {
  1: volumeSeller,
  2: tradeRevDirectSeller
};

export default iconMap;
